import MenuActions from './Menu';

const ACTION = {
  ...MenuActions.ACTION
};

const ACTION_TYPES = {
  ...MenuActions.ACTION_TYPES
};

const Menu = {
  ACTION,
  ACTION_TYPES
}

export default Menu;